import React from 'react';
import { observer } from 'mobx-react';

import { Image, Text, Button, Box } from '@chakra-ui/react';
import { staticURL } from 'core/url';

export const EmptyConnTable = observer(
  ({
    height,
    contentName,
    conn,
  }: {
    height: number;
    contentName: string;
    conn: any;
  }) => {
    let imageHeight = 200;
    if (height - 40 <= imageHeight) imageHeight = Math.max(height - 40, 80);
    // Add condition based on applued Fiters instead of localFilters in the URL
    let contentElement = (
      <Box>
        <Text as='small' fontSize='md' color='black'>
          No {contentName} match Filters.
        </Text>
        <Button
          display='block'
          ml='12'
          mt='6'
          variant='outline'
          borderRadius='20px'
          fontWeight='regular'
          color='blue'
          size='sm'
          onClick={() => {
            conn.ClearFilters();
            conn.ApplyFilters();
          }}
        >
          Clear Filters
        </Button>
      </Box>
    );

    if (conn?.appliedFilters && Object.keys(conn.appliedFilters).length === 0) {
      contentElement = (
        <Text as='small' fontSize='md' color='black'>
          No {contentName} yet.
        </Text>
      );
    }

    return (
      <Box minHeight={height} position='relative'>
        <Box
          position='absolute'
          left={0}
          right={0}
          bottom={0}
          top={0}
          display='flex'
          alignItems='center'
          justifyContent='center'
          flexDirection='row'
          bg='gray.50'
        >
          <Image
            mr={6}
            src={staticURL('/assets/banners/trimmed/005.svg')}
            height={`${imageHeight}px`}
          />
          {contentElement}
        </Box>
      </Box>
    );
  },
);
